import React from 'react';
import { Typography } from '@mui/material';
import GavelIcon from '@mui/icons-material/Gavel';
import PolicyPage from './components/PolicyPage';
import { RouteSeo } from './components/RouteSeo';

const TermsOfService = () => {
  return (
    <>
    <RouteSeo
      title="Terms of Service | Aylet Aib"
      canonicalPath="/terms"
      description="Terms governing your use of Aylet Aib services, website, and applications."
    />
    <PolicyPage 
      title="Terms of Service"
      icon={<GavelIcon />}
    >
      <Typography component="h2" variant="h5" gutterBottom sx={{ 
        fontWeight: 600,
        fontSize: { xs: '1.2rem', sm: '1.3rem', md: '1.5rem' }
      }}>
        Agreement to Terms
      </Typography>
      <Typography paragraph sx={{ mb: 3 }}>
        These Terms of Service ("Terms") govern your access to and use of the Aylet Aib website, services, and applications ("Services"). Please read these Terms carefully, and contact us if you have any questions.
      </Typography>

      <Typography paragraph>
        By accessing or using our Services, you agree to be bound by these Terms and our Privacy Policy. If you do not agree to these Terms, you may not access or use the Services.
      </Typography>

      <Typography component="h2" variant="h5" gutterBottom sx={{ 
        fontWeight: 600,
        fontSize: { xs: '1.2rem', sm: '1.3rem', md: '1.5rem' },
        mt: 4 
      }}>
        Use of Services
      </Typography>
      <Typography paragraph>
        You may use our Services only as permitted by these Terms and any applicable laws. You may not use our Services:
      </Typography>
      <ul>
        <li>
          <Typography paragraph>
            In any way that violates any applicable federal, state, local, or international law or regulation
          </Typography>
        </li>
        <li>
          <Typography paragraph>
            To transmit any material that is defamatory, obscene, or offensive
          </Typography>
        </li>
        <li>
          <Typography paragraph>
            To impersonate or attempt to impersonate Aylet Aib, an employee, or any other person
          </Typography>
        </li>
        <li>
          <Typography paragraph>
            To engage in any conduct that restricts or inhibits anyone's use of the Services
          </Typography>
        </li>
      </ul>

      <Typography component="h2" variant="h5" gutterBottom sx={{ 
        fontWeight: 600,
        fontSize: { xs: '1.2rem', sm: '1.3rem', md: '1.5rem' },
        mt: 4
      }}>
        WhatsApp Communications
      </Typography>
      <Typography paragraph>
        By accessing or using Aylet Aib's website and services, you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you may not access our services.
      </Typography>
      <Typography paragraph>
        Our use of WhatsApp is subject to WhatsApp's own Terms of Service. Our business complies with the WhatsApp Business Policy for all communications.
      </Typography>

      <Typography component="h2" variant="h5" gutterBottom sx={{ 
        fontWeight: 600,
        fontSize: { xs: '1.2rem', sm: '1.3rem', md: '1.5rem' },
        mt: 4
      }}>
        Intellectual Property
      </Typography>
      <Typography paragraph>
        The Services and all of their contents, including but not limited to text, images, graphics, logos, and software, are the property of Aylet Aib or its licensors and are protected by copyright, trademark, and other intellectual property laws.
      </Typography>

      <Typography component="h2" variant="h5" gutterBottom sx={{ 
        fontWeight: 600,
        fontSize: { xs: '1.2rem', sm: '1.3rem', md: '1.5rem' },
        mt: 4
      }}>
        Prohibited Activities
      </Typography>
      <Typography paragraph>
        In addition to other prohibitions as set forth in the Terms of Service, you are prohibited from using the site or its content:
      </Typography>
      <ul>
        <li>
          <Typography paragraph>
            For any unlawful purpose
          </Typography>
        </li>
        <li>
          <Typography paragraph>
            To solicit others to perform or participate in any unlawful acts
          </Typography>
        </li>
        <li>
          <Typography paragraph>
            To violate any international, federal, provincial or state regulations, rules, laws, or local ordinances
          </Typography>
        </li>
      </ul>

      <Typography component="h2" variant="h5" gutterBottom sx={{ 
        fontWeight: 600,
        fontSize: { xs: '1.2rem', sm: '1.3rem', md: '1.5rem' },
        mt: 4
      }}>
        Contact Us
      </Typography>
      <Typography paragraph>
        If you have any questions about these Terms, please contact us at: info@ayletaib.com
      </Typography>
    </PolicyPage>
    </>
  );
};

export default TermsOfService; 